const appType = {
    private: 'Private',
    public: 'Public',
};

export default appType;
